<template>
    <div style="height: 100%">
      <!--告警分布-->
      <label style="margin-top: 15px;font-weight: bold;margin-left: 25px;">告警分布</label>
      <pie-chart :data="alarmData" :extendData="extendData" id="AlarmDistribution" ref="pieChart" :route="route"
                 style="height: 80%;"></pie-chart>
    </div>
</template>

<script>
import PieChart from '@/components/echarts/PieChart';
import {getLevelCount} from '@/network/alarm-realtime';

export default {
  name: "AlarmDistribution",
  components: {PieChart},
  data() {
    return {
      alarmData: [],
      extendData: null,
      route:'/realTime-alarm'
    }
  },
  created() {
    this.getData();
    this.$store.dispatch('addIntervalObj', {'getAlarmDistribution:5000': this.getData})
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getAlarmDistribution')
  },
  mounted() {
    this.extendData = {
      series: [{
        radius: ["62%", "42%"],
        center: ['40%', '45%'],
      }, {
        center: ['40%', '45%'],
      }],
      legend: {
        right: '10%',
        top: '25%',
        bottom: '14%',
        type: 'scroll',
        pageIconInactiveColor: "#999",
        pageIconColor: "#01EFFD",
        pageTextStyle: {
          color: "#01EFFD"
        },
        pageIconSize: [12, 12]
      },
    }
  },
  methods: {
    getData() {
      getLevelCount().then(res => {
        if (res.code === 0) {
          this.alarmData = res.data
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
